<template>
  <v-dialog v-model='dialog' v-on:input='closeStatuses' scrollable max-width='700px'>
    <v-icon slot='activator' small v-on:click='getStatusChanges(item)'>change_history</v-icon>
    <v-card>
      <v-card-text>
        <v-data-table :headers='headers' :items='statusChanges' class='elevation-1' hide-actions>
          <template v-slot:items='props'>
            <td class='text-xs-left'>{{ props.item.created_at }}</td>
            <td class='text-xs-left'>{{ props.item.status_before_name }}</td>
            <td class='text-xs-left'>{{ props.item.status_after_name }}</td>
            <td class='text-xs-left'>{{ props.item.userName }}</td>
          </template>
          <template v-slot:no-data>{{$t('status_changes.no_status_changes')}}</template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['item', 'table'],
  data() {
    return {
      dialog: false,
      statusChanges: [],
      headers: [],
    };
  },

  async created(){
    this.getText();
  },

  methods: {

    getText(){
      this.headers = [
        { text: this.$t('status_changes.date'), value: 'created_at', sortable: false },
        { text: this.$t('status_changes.before'), value: 'status_before', sortable: false },
        { text: this.$t('status_changes.after'), value: 'status_after', sortable: false },
        { text: this.$t('status_changes.who_changed'), value: 'userName', sortable: false }
      ]
    },  

    closeStatuses() {
      if (!this.showChanges) {
        this.statusChanges = [];
      }
    },

    /**
     * gets actions from database
     */
    getStatusChanges(item) {
      this.requestStatusChanges(item).then(response => {
        this.statusChanges = response.data;
      });
    },

    /**
     * http request to get actions from database
     */
    requestStatusChanges(item) {
      let params = {
        table_name: this.table,
        table_id: item.id,
        language: this.$router.currentRoute.params.lang.toUpperCase()
      };
      return this.$http.get(process.env.VUE_APP_ROOT_API + '/actions', {
        headers: {
          Authorization: 'Bearer' + ' ' + this.$session.get('jwt')
        },
        params
      });
    }
  }
};
</script>
